export default "__VITE_ASSET__CeU6nkWG__"